// https://developer.mozilla.org/en-US/docs/Learn/Common_questions/What_is_a_URL

const SCHEME = process.env.REACT_APP_API_SCHEME || 'https';

export const API_AUTHORITY = process.env.REACT_APP_API_AUTHORITY;

const API_ROOT_PATH = 'api/authentication';
const API_PATHS: { [key: string]: string } = {
  signIn: `login`,
  signUp: `register`,
  signOut: `logout`,
  createAccount: 'createAccount',
  generateVerificationToken: 'generateVerificationToken', // TODO: remove once email sending is sorted out
  sendVerificationEmail: 'sendVerificationEmail',
  verifyAccount: 'verifyAccount',
  setupPassword: 'setupPassword',
  accountDetails: 'profile',
  countryCodes: 'countryCodes',
};

export const getApiOrigin = (): string =>
  API_AUTHORITY ? `${SCHEME}://${API_AUTHORITY}` : '';

export const buildApiUrl = (pathName: string): string => {
  const apiPath = API_PATHS[pathName];
  return `${getApiOrigin()}/${API_ROOT_PATH}/${apiPath}`;
};
